export default "__VITE_ASSET__BRlpRBaj__"